<div class="cointainer-fluid mb-4">
    <div class="row">
        <div class="col-12">
            <iframe  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1811.581510018287!2d5.197090606055848!3d43.38288836035804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12c9e7965729a5e9%3A0xc34ced8a66b5bfd4!2s1655%20Avenue%20de%20la%20M%C3%A9diterran%C3%A9e%2C%2013180%20Gignac-la-Nerthe%2C%20Francia!5e0!3m2!1sit!2sit!4v1603466535735!5m2!1sit!2sit" width="100%" height="400" frameborder="0" style="border:0;" allowfullscreen="true" aria-hidden="false" tabindex="0"></iframe>
        </div>
    </div>
</div>

  <div class="container mb-5">
    <div class="row">
      <div class="col-12 col-md-8 mb-5 mb-md-0">
        <h1 class="">
            {{ 'CONTATTI' | translate | htmlToText  }}
        </h1>
        <p class="mb-5"> {{ 'TESTO_CONTATTI' | translate | htmlToText  }}</p>
        <form name="form" (ngSubmit)="f.form.valid && inviaContatto()" #f="ngForm" novalidate>
          <div class="form-row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="nome" class="font-weight-semi-bold small"> {{ 'NOME_COGNOME_CONTATTI' | translate | htmlToText  }}*</label>
                <input type="text" class="form-control" name="nome" id="nome" aria-describedby="" placeholder=""
                #nome="ngModel" [(ngModel)]="contatto.nome" required [ngClass]="{ 'is-invalid': f.submitted && nome.invalid }">
                <div *ngIf="f.submitted && nome.invalid" class="invalid-feedback">
                    <div *ngIf="nome.errors.required" class="is-invalid small">{{ 'NOME_COGNOME_CONTATTI' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                  </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="email" class="font-weight-semi-bold small"> {{ 'EMAIL' | translate | htmlToText  }}*</label>
                <input type="email" class="form-control" name="email" id="email" aria-describedby="email" placeholder="" 
                #email="ngModel" [(ngModel)]="contatto.email" required email [ngClass]="{ 'is-invalid': f.submitted && email.invalid }">
                <!-- ERRORE DATO INVALIDO -->
               <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                    <div *ngIf="email.errors.required" class="is-invalid small">{{ 'EMAIL' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                    <div *ngIf="email.errors.email" class="is-invalid small">{{ 'DATO_NON_VALIDO' | translate | htmlToText  }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <div class="form-group">
                <label for="oggetto" class="font-weight-semi-bold small"> {{ 'OGGETTO_CONTATTI' | translate | htmlToText  }}*</label>
                <input type="text" class="form-control" name="nome" id="nome" aria-describedby="" placeholder=""
                  #oggetto="ngModel" [(ngModel)]="contatto.oggetto" required [ngClass]="{ 'is-invalid': f.submitted && nome.invalid }">
                <div *ngIf="f.submitted && oggetto.invalid" class="invalid-feedback">
                    <div *ngIf="oggetto.errors.required" class="is-invalid small">{{ 'OGGETTO_CONTATTI' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                  </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <div class="form-group">
                <label for="messaggio" class="font-weight-semi-bold small"> {{ 'MESSAGGIO_CONTATTI' | translate | htmlToText  }}*</label>
                <textarea class="form-control" name="messaggio" id="messaggio" aria-describedby="" placeholder=""
                #messaggio="ngModel" [(ngModel)]="contatto.messaggio" required [ngClass]="{ 'is-invalid': f.submitted && messaggio.invalid }"></textarea>
                <div *ngIf="f.submitted && nome.invalid" class="invalid-feedback">
                    <div *ngIf="messaggio.errors.required" class="is-invalid small">{{ 'MESSAGGIO_CONTATTI' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-check">
                <input class="form-check-input" required type="checkbox" value="" id="check-newsletter"  name="check-newsletter" [(ngModel)]="contatto.termRiserv"
                #privacy="ngModel" [ngClass]="{ 'is-invalid': f.submitted && privacy.invalid }">
                <label class="form-check-label small" for="check-newsletter">
                    {{ 'ACCETTO_LA' | translate | htmlToText  }} <span [innerHTML]="'PRIVACY_POLICY' | translate" class="text-underline"> </span>*
                </label>
                <div *ngIf="f.submitted && privacy.invalid" class="invalid-feedback">
                    <div *ngIf="privacy.errors.required">{{ 'PRIVACY' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                  </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group my-3">
                <re-captcha
                  (error)="resolved(false)"
                  (resolved)="resolved(true)"
                  siteKey="6Ld_do4aAAAAAA6YlQaQJGWTrezfpEZ477t23_UM"
                ></re-captcha>
                <button class="btn btn-stem mr-4 mt-3"  type="submit" *ngIf="showSubmit">
                    {{ 'INVIA' | translate | htmlToText  }}
                </button>
            
              </div>
              <div class="small">* {{ 'CAMPI_OBBLIGATORI' | translate | htmlToText  }}</div>
              <!-- ERRORE GENERICO -->
              <div class="is-invalid small" *ngIf="errore"><i> {{ 'ERRORE_RIPROVA' | translate | htmlToText  }}</i></div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 col-md-4">
        <div class="row mb-5">
          <div class="col-12">
            <h2 class="text-center"> {{ 'SEGUICI_SOCIAL' | translate | htmlToText  }}</h2>
          </div>
          <div class="col-12">
            <div class="social-icons mt-5 mt-md-3 mb-5 mb-md-0 d-flex justify-content-center">
              <button type="button" (click)='openFacebook()' class="fb-button fb-contacts mx-3 mr-md-3 ml-md-0"><i class="fab fa-facebook"></i></button>
              <a href="https://www.linkedin.com/company/stem-technology/" target="_blank"><i class="fab fa-linkedin d-inline-flex mx-3 mr-md-3 ml-md-0"></i></a>
              <a href="https://www.instagram.com/stem_ems/" target="_blank"><i class="fab fa-instagram d-inline-flex mx-3 mr-md-3 ml-md-0"></i></a>
              <a href="https://www.youtube.com/channel/UCs6NtZ-STb1daZPdHlO54kw" target="_blank"><i class="fab fa-youtube d-inline-flex mx-3 mr-md-3 ml-md-0"></i></a>
            </div>
          </div>
        </div>
        <div class="row mb-5 text-center">
          <div class="col-12 mb-5">
            <img src="../../../assets/img/Logo-stem-france-blu.webp" class="img-fluid" style="width: 150px;height: auto;">
          </div>
          <div class="col-12 mb-3">
            <h6> {{ 'INDIRIZZO' | translate | htmlToText  }}</h6>
            <p>
                {{ 'VIA_CONTATTI' | translate | htmlToText  }} <br> {{ 'CITTA_CONTATTI' | translate | htmlToText  }} <br> {{ 'NAZIONE_CONTATTI' | translate | htmlToText  }}
            </p>
          </div>
          <div class="col-12 mb-3">
            <h6> {{ 'CONTATTI' | translate | htmlToText  }}</h6>
            <p class="mb-0"><a href="mailto: {{ 'MAIL_CONTATTI' | translate | htmlToText  }}" class="text-underline"> {{ 'MAIL_CONTATTI' | translate | htmlToText  }}</a></p>
            <p class="mb-0"><span class="font-weight-semi-bold"> {{ 'ACCUEIL' | translate | htmlToText  }}: </span><a class="text-underline" href="tel:{{ 'TEL_ACCUEIL' | translate | htmlToText  }}"> {{ 'TEL_ACCUEIL_CONTATTI' | translate | htmlToText  }}</a></p>
            <p><span class="font-weight-semi-bold"> {{ 'FAX' | translate | htmlToText  }}: </span> {{ 'FAX_CONTATTI' | translate | htmlToText  }}</p>
            
          </div>
          <div class="col-12 mb-3">
            <h6> {{ 'ORARI' | translate | htmlToText  }}</h6>
            <p class="mb-0"><span class="font-weight-semi-bold"> {{ 'LUN_GIO' | translate | htmlToText  }}: </span> {{ 'ORARI_LUN_GIO' | translate | htmlToText  }}</p>
            <p class="mb-0"><span class="font-weight-semi-bold"> {{ 'VEN_DOM' | translate | htmlToText  }}: </span> {{ 'ORARI_VEN_DOM' | translate | htmlToText  }}</p>
            
          </div>
        </div>
        
        
      </div>
    </div>
  </div>


    <!-- Modal -->
    <div class="modal fade show" [class.d-block]="showModal" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog mt-5 pt-5" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">{{'INVIO_CONTATTI_SUCCESS' | translate | htmlToText}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="showModal = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>